import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CentralClientePacoteDetalharRoutingModule } from './central-cliente-pacote-detalhar-routing.module';
import { CentralClientePacoteDetalharComponent } from './central-cliente-pacote-detalhar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DialogModule } from 'primeng/dialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { TooltipModule } from 'primeng/tooltip';


@NgModule({
  declarations: [
    CentralClientePacoteDetalharComponent
  ],
  imports: [
    CommonModule,
    CentralClientePacoteDetalharRoutingModule,
    FormsModule,
    TableModule,
    DividerModule,
    MessagesModule,
    InputTextModule,
    ButtonModule,
    ProgressSpinnerModule,
    DialogModule,
    DropdownModule,
    RadioButtonModule,
    CalendarModule,
    TooltipModule
  ]
})
export class CentralClientePacoteDetalharModule { }
